var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.4507L20.7921 27.7444C21.0639 27.9221 21.3787 28.0106 21.6974 27.999C22.016 27.9874 22.3244 27.8762 22.5843 27.6791C22.8441 27.4821 23.0439 27.208 23.1588 26.8908C23.2737 26.5737 23.2987 26.2275 23.2306 25.8953L21.4302 17.8185L27.4363 12.374C27.6791 12.1544 27.8547 11.8625 27.9407 11.5356C28.0267 11.2088 28.019 10.8619 27.9187 10.5398C27.8184 10.2176 27.63 9.9348 27.3777 9.72772C27.1255 9.52064 26.8209 9.39875 26.5032 9.37772L18.5987 8.6758L15.5055 1.03958C15.3753 0.729933 15.1639 0.46704 14.8968 0.282589C14.6297 0.0981387 14.3182 0 14 0C13.6818 0 13.3704 0.0981387 13.1032 0.282589C12.8361 0.46704 12.6247 0.729933 12.4945 1.03958L9.40134 8.65806L1.49679 9.35999C1.17907 9.38101 0.874514 9.5029 0.622274 9.70998C0.370034 9.91706 0.181641 10.1999 0.0813164 10.522C-0.0190083 10.8442 -0.0266782 11.191 0.0592923 11.5179C0.145263 11.8447 0.320944 12.1367 0.563749 12.3562L6.56984 17.8008L4.76942 25.8813C4.7011 26.2135 4.72589 26.5599 4.84071 26.8772C4.95554 27.1945 5.15532 27.4688 5.4152 27.666C5.67508 27.8631 5.98359 27.9744 6.30234 27.9861C6.62109 27.9977 6.93601 27.9091 7.20791 27.7313L14 23.4507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9cb1f8e7a8b7770d5cb04536bd3c81ef.svg";
export { ForwardRef as ReactComponent };